/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import PropTypes from 'prop-types'
import { isString } from 'lodash'
import classes from 'classnames'

import { translate } from 'parking-react-common'

import { ui } from '../redux'

import Button from '../components/Button'
import LoadingIndicator from '../components/LoadingIndicator'

import './ImageUpload.css'

const ImageUpload = (props) => {
    const { label, url, noImageText, onChange, onDelete, isUploading, t } = props

    return (
        <div>
            <label htmlFor="files">{ label }</label>
            <div className={ classes('img-thumbnail', 'imageContainer') }>
                <label htmlFor="files" className="label" style={ onChange && { cursor: 'pointer' } }>
                    { !isString(url) && !isUploading && onChange && (
                        <Button
                            icon="md/file-upload"
                            label={ t('Upload image') }
                            className="uploadButton"
                            intent={ ui.INTENT.primary }
                        />
                    ) }
                    { isString(url) && onDelete && (
                        <Button
                            onClick={ () => onDelete(url) }
                            icon="md/close"
                            intent={ ui.INTENT.danger }
                            size={ ui.SIZE.large }
                            className="deleteButton"
                        />
                    ) }
                    { !isString(url) && !onChange && noImageText
                        ? <span className="noImageText">{ noImageText }</span>
                        : null
                    }
                    { isUploading && <LoadingIndicator size={ 25 } isVisible={ isUploading } /> }
                </label>
                <img src={ url } alt="" />
            </div>
            { onChange && (
                <input
                    id="files"
                    type="file"
                    style={ { display: 'none' } }
                    onChange={ (event) => {
                        onChange(event.target.files[0])
                    } }
                />
            )}
        </div>
    )
}

ImageUpload.propTypes = {
    url         : PropTypes.string,
    label       : PropTypes.string,
    onDelete    : PropTypes.func,
    onChange    : PropTypes.func,
    noImageText : PropTypes.string,
    isUploading : PropTypes.bool
}

export default translate()(ImageUpload)
